<script>
	import { UserInfo, IsNative } from '$lib/store.js';
	import { goto } from '$app/navigation';
	import Connect from '../../../../components/connect/Connect.svelte';
	import DownloadConnect from '../../../../components/connect/DownloadConnect.svelte';

	// if (!($UserInfo.sourcesUsed || []).length) goto('/onboard/companies');
	// else if (!($UserInfo.valueProps || []).length) goto('/onboard/value');

	let mainUnderstand = ['facebook', 'google', 'twitter', 'linkedin', 'instagram'];
	let mainControl = ['facebook', 'google', 'twitter'];
	let mainUse = ['apple', 'twitter', 'spotify'];
	let understandCompanies = mainUnderstand?.filter((source) =>
		($UserInfo.sourcesUsed || []).includes(source)
	);
	let controlCompanies = mainControl?.filter((source) =>
		($UserInfo.sourcesUsed || []).includes(source)
	);
	let byAPICompanies = mainUse?.filter((source) => ($UserInfo.sourcesUsed || []).includes(source));
	let understand = ($UserInfo.valueProps || []).includes('understand');
	let control = ($UserInfo.valueProps || []).includes('control');
	let use = ($UserInfo.valueProps || []).includes('use');
	let understandControl = understand || control;
	let selected;
</script>

<h1 class="text-lg text-center">Our recommended path for you</h1>
<div class="max-w-3xl w-full flex mt-4 {understandControl ? 'flex-col' : 'flex-col-reverse'}">
	<!-- Now, Then, Later -->
	<!-- Get data (Download big chunks, connect API), understand data, delete data, use data -->
	<!-- Download big chunks is always at the start or end depending on whether they want to understand -->
	<!-- use & understand data are dependent on data and usage of platforms -->
	<!-- delete data just dependent on desire to delete data and usage of platforms-->
	{#if understandCompanies?.length && !$IsNative}
		<card class="w-full">
			<div class="stepNumber">{understandControl ? 1 : 2}</div>
			<p>
				{understandCompanies?.length && understandControl
					? 'Trigger'
					: 'Then later, if you want to analyse data that you need to download manually, you can trigger'}
				a download of your data from:
			</p>
			<DownloadConnect sources={understandCompanies.slice(0, 1)} />
		</card>
	{/if}
	<card class="w-full">
		<div class="stepNumber">
			{understandControl && understandCompanies?.length && !$IsNative ? 2 : 1}
		</div>
		{#if byAPICompanies?.length}
			<p>
				{understandCompanies?.length && understandControl && !$IsNative
					? "While you're waiting for your data to be ready, get"
					: 'Get'}
				started by instantly connecting your Magicflow account via API to explore our analysis of:
			</p>
			<Connect sources={byAPICompanies} />
		{:else}
			<p>
				{understandCompanies?.length && understandControl && !$IsNative
					? "While you're waiting for your data to be ready, you"
					: 'You'}
				can explore Magicflow in demo mode to get a sense of what you can find. Unfortunately the only
				data sources you can connect instantly via API are Twitter and Spotify.
			</p>
		{/if}
		{#if ($UserInfo.sourcesUsed || []).includes('apple') && ($UserInfo.valueProps || []).includes('use')}
			<p>To connect your Apple Health data, you'll need to download our mobile app!</p>
		{/if}
	</card>
</div>
<card class="max-w-3xl w-full">
	<div class="stepNumber">
		{understandCompanies?.length && !$IsNative ? 3 : 2}
	</div>
	{#if understandCompanies?.length && !$IsNative}
		<p>
			When the big data dumps are ready, you can come back, upload them to Magicflow and analyse the
			data they hold.
		</p>
	{/if}
	{#if use && understandCompanies?.length}
		<p>
			You can regularly upload updated data from
			{understandCompanies.join(', ')}, to see how the latest updates affect metrics you're
			tracking, like mood!
		</p>
	{/if}
	<p>
		{#if control}
			{#if controlCompanies?.length}
				Then, you can use TraceErase
				{#if $IsNative}on your laptop (it's a Chrome extension){/if}
				to delete data from supported companies (Twitter, Facebook, Google) that you don't want them
				to keep.
			{:else}
				Unfortunately, we don't yet support deletion for the companies you've selected ({$UserInfo.sourcesUsed
					.map((string) => string?.[0].toUpperCase() + string.slice(1))
					.join(', ')}).
			{/if}
		{/if}
	</p>
</card>
{#if use}
	<card class="max-w-3xl w-full">
		<div class="stepNumber">
			{understandCompanies?.length && control && !$IsNative
				? 4
				: (understandCompanies?.length && !$IsNative) || control
				  ? 3
				  : 2}
		</div>
		<img
			style="max-height: 25vh; border-radius: 1rem;"
			class="mx-auto my-4"
			src="placeholders/moodRainbow.webp"
			alt="Mood graph in a rainbow shape showing happiness, energy, calm and focus levels"
		/>
		<p>
			You can track your happiness, energy, stress/calm and focus levels in Magicflow, and use the
			data from other services to find out what causes these things to change.
		</p>
	</card>
{/if}

<a sveltekit:prefetch href="/" class="block mx-auto">
	<button class="flip block rounded-lg text-2xl font-semibold"> Get Started </button>
</a>

<style lang="postcss">
	card.w-full {
		@apply mb-8 relative;
	}
	.stepNumber {
		@apply absolute rounded-2xl w-8 h-8 flex items-center z-50 justify-center left-1/2 top-0 transform -translate-x-1/2 -translate-y-1/2 border-white border-2 font-semibold bg-gray-900;
	}
	p {
		margin: 0.5rem;
		font-weight: 500;
	}
</style>
